import { useMutation, useQuery } from "@tanstack/react-query";
import { RoleDto, SearchRoleDto } from "../../../services/dto";
import { IActionResult } from "../../../assets/utils/lib";
import { RoleClient } from "../../../services/proxies";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace RoleService {
  const roleClient = new RoleClient();

  export const save = () =>
    useMutation<IActionResult<RoleDto>, Error, RoleDto>({
      mutationFn: async (payload: RoleDto) => {
        return await roleClient.saveRoleAsync(payload);
      },
    });

  export const getRoleQuery = (roleId: string | undefined) =>
    useQuery({
      queryKey: ["roleQuery", roleId],
      queryFn: async () => await roleClient.getRoleAsync(roleId),
      enabled: Boolean(roleId) && roleId !== Constants.emptyGuid,
    });

  export const getRolesQuery = () =>
    useQuery({
      queryKey: ["rolesQuery"],
      queryFn: async () => await roleClient.getRolesAsync(),
    });

  export const gridQuery = (searchQuery: SearchRoleDto) =>
    useQuery({
      queryKey: ["roleGridQuery", searchQuery],
      queryFn: async () => await roleClient.searchRolesAsync(searchQuery),
      placeholderData: (previousData) => previousData,
    });
}
